import {useMapContext} from '@/components/MindMap/index.mjs'
import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Check from '../../SidePanel/RightPanel/PropertiesControllerCheck.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonLintCode from '../_DESIGN/PropertiesPaneButtonLintCode.jsx'
import Bm from '../BM/PropertiesControllerBm.jsx'
import Fm from '../FM/PropertiesControllerFm.jsx'
import Ss from '../SS/PropertiesControllerSs.jsx'
import Vm from '../VM/PropertiesControllerVm.jsx'
import ButtonPreview from './PropertiesPaneButtonPreview.jsx'
import Model from './ModelUi.mjs'
import TerminalType from './TerminalType.jsx'
import UiLayoutType from './PropertiesControllerUiLayoutType.jsx'
import Ut from './PropertiesControllerUt.jsx'

export default function PropertiesPaneUi(props) {
    const map = useMapContext()
    const {prjTypeCode} = map.data

    const module = (() => {
        if ('BM' === prjTypeCode) {
            return <Bm />
        }
        else {
            return <Fm />
        }
    })()

    return (
        <ProductPropertiesPane
            buttons={
                <>
                    <ButtonPreview />
                    <ButtonLintCode />
                </>
            }

            controllers={
                <>
                    <Ss isUi={1} />
                    {module}
                    <Vm />
                    <Text prop="uiUserCode" />
                    <Text prop="uiPgCode" />
                    <Text prop="uiName" />
                    <UiLayoutType />

                    <Select
                        options={TerminalType}
                        prop="terminalType"
                    />

                    <Check
                        falseValue="0"
                        trueValue="1"
                        prop="independentUiFlag"
                    />

                    <Ut />
                    <LongText prop="memo" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'CallUiDepend',
                        'CallUiEffect',
                        //'Depend',
                        'Effect',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
